((State, $) => {
  const state = {
    breakpoint: null
  };

  const getWindowBreakpoint = () => {
    const window_width = window.innerWidth;
    if (window_width < 768) {
      return `mobile`;
    } else if ( window_width < 1024) {
      return `tablet`;
    } else {
      return `desktop`;
    }
  };

  const setBreakpoint = window.Helpers.debounce(() => {
    const window_breakpoint = getWindowBreakpoint();
    if (state.breakpoint === window_breakpoint) {
      return;
    }
    state.breakpoint = window_breakpoint;
    $(window).trigger(`breakpointChange`, state.breakpoint);
  }, 300);

  const getBreakpoint = () => {
    return state.breakpoint;
  };

  const bindUIActions = () => {
    $(window).on('resize', (e) => {
      setBreakpoint();
    });
  };

  const init = () => {
    setBreakpoint();
    bindUIActions();
  };

  State.init = init;
  State.getBreakpoint = getBreakpoint;
})((window.State = window.State || {}), jQuery);